/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import "./MenuSummaryAlignPicker.css";
import "./MenuTitlesAlignPickers.css";
import { TITLE_ALIGNS } from "../../../constants/titleAlign";

/**
 * Labels reuse summary alignment keys for Left / Center / Right.
 */
const ALIGN_LABEL_KEYS = {
  left: "menuSummaryAlignLeft",
  center: "menuSummaryAlignCenter",
  right: "menuSummaryAlignRight",
};

function TitleAlignRadios({
  idPrefix,
  groupLabelKey,
  value,
  onChange,
}) {
  const { t } = useTranslation();
  return (
    <div className="menu-titles-align-pickers__block">
      <div className="menu-summary-align-picker__title menu-titles-align-pickers__row-label">
        {t(groupLabelKey)}
      </div>
      <div
        className="menu-summary-align-picker__row"
        role="radiogroup"
        aria-label={t(groupLabelKey)}
      >
        {TITLE_ALIGNS.map((align) => (
          <button
            key={align}
            type="button"
            role="radio"
            aria-checked={value === align}
            id={`${idPrefix}-${align}`}
            className={`menu-summary-align-picker__btn ${
              value === align ? "menu-summary-align-picker__btn--active" : ""
            }`}
            onClick={() => onChange(align)}
          >
            {t(ALIGN_LABEL_KEYS[align])}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function MenuTitlesAlignPickers({
  categoryTitleAlign,
  subCategoryTitleAlign,
  productTitleAlign,
  onCategoryTitleAlignChange,
  onSubCategoryTitleAlignChange,
  onProductTitleAlignChange,
  idPrefix = "menu-titles-align",
}) {
  const { t } = useTranslation();

  return (
    <div className="menu-titles-align-pickers menu-summary-align-picker">
      <div className="mcds">
        <div className="mcds__header">
          <span className="mcds__header-icon" aria-hidden>
            <i className="fa fa-align-center" />
          </span>
          <div className="mcds__header-text">
            <div className="mcds__title">{t("menuTitlesAlignSectionTitle")}</div>
            <div className="mcds__subtitle">{t("menuTitlesAlignSectionSubtitle")}</div>
          </div>
        </div>
      </div>
      <p className="menu-summary-align-picker__hint menu-titles-align-pickers__main-hint">
        {t("menuTitlesAlignMainHint")}
      </p>

      <TitleAlignRadios
        idPrefix={`${idPrefix}-category`}
        groupLabelKey="menuTitlesAlignCategory"
        value={categoryTitleAlign}
        onChange={onCategoryTitleAlignChange}
      />
      <TitleAlignRadios
        idPrefix={`${idPrefix}-subcategory`}
        groupLabelKey="menuTitlesAlignSubcategory"
        value={subCategoryTitleAlign}
        onChange={onSubCategoryTitleAlignChange}
      />
      <TitleAlignRadios
        idPrefix={`${idPrefix}-product`}
        groupLabelKey="menuTitlesAlignProduct"
        value={productTitleAlign}
        onChange={onProductTitleAlignChange}
      />
    </div>
  );
}
